<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="players.length == 0">
        <p>No players data found.</p>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="team-players-section">
            <div class="team-players-head">
                <div class="head-left">
                    <strong class="h2 text-uppercase">Players</strong>
                </div>
                <div class="dropdown sort-dropdown">
                    <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:;" class="dropdown-toggle" >{{(category == 'all')?'All':category}} <i class="ico-down-arrow"></i></span>
                    <div class="dropdown-menu">
                        <button type="button" class="dropdown-item"  @click="category = 'all' ">All</button>
                        <button type="button" class="dropdown-item"  @click="category = 'ODI' ">ODI</button>
                        <button type="button" class="dropdown-item"  @click="category = 'T20' ">T20</button>
                        <button type="button" class="dropdown-item"  @click="category = 'Test' ">TEST</button>
                    </div>
                </div>
            </div>
            <div class="player-post-holder">
                <div class="player-post" v-for="(item,index) in filteredPlayers" :key="index" v-if="item.player">
                    <router-link class="player-inn"  :to="{ name: 'playerDetail.info', params:  {  player: item.player.slug } }">
                                 <div class="avtar" v-if="item.player.gender == 'male' || item.player.gender == 'Male' || item.player.gender == 'M' || item.player.gender == 'MALE'">
                            <img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+item.player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Male.jpg'" alt="">
                        </div>
                        <div class="avtar" v-else-if="item.player.gender == 'female' || item.player.gender == 'Female' || item.player.gender == 'F' || item.player.gender == 'FEMALE'">
                            <img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+item.player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Female.jpg'" alt="">
                        </div>
                        <div class="avtar" v-else>
                            <img :src="('https://img.sixlogics.com/avatars/cricket/players/300x300/'+item.player.id+'.png').resizeImage(90)"   @error="$event.target.src='/public/images/User_Male.jpg'" alt="">
                        </div>
                        <div class="descrip">
                            <span class="icon-flag"><img :title="item.player.country.name" :src="'https://api.planetcricket.com/storage/country_flags/'+ item.player.country_id +'.png'" alt=""></span>
                            <div class="descrip-top d-none d-md-block">
                                <strong class="name">{{item.player.name}} </strong>
                            </div>
                            <div class="descrip-top d-md-none">
                                <strong class="name">{{item.player.short_name}}</strong>
                            </div>
                            <ul class="descrip-list">
                                <li>
                                    <!-- <span class="title">Playing role</span> -->
                                    <span class="sub-title"><span class="text">{{item.player.role = item.player.role.charAt(0).toUpperCase() + item.player.role.slice(1) }}</span></span>
                                </li>
                                <li>
                                    <!-- <span class="title">Nationality</span> -->
                                    <span class="sub-title"><span class="text">{{item.player.gender = item.player.gender.charAt(0).toUpperCase() + item.player.gender.slice(1)}}</span></span>
                                </li>
                                <li>
                                    <!-- <span class="title">DOB</span> -->
                                    <span class="sub-title"><span class="text">{{item.player.age? item.player.age + ' Years': ''}} </span></span>
                                </li>
                            </ul>
                        </div>
                    </router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Vue from 'vue'
    export default {
        name: 'team_Players',
        data() {
            return {
                players: [],
                category: 'all',
                SortBy: '',
                // age: ''
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
                let persons = []
               this.players.currentPlayers.forEach((element) => {
                persons.push(
                        {
                            '@type': 'Person',
                            "name": element.player.name,
                            "alternateName": element.player.nick,
                            "address": element.player.birth_place,
                            "height": element.player.height,
                            "weight": element.player.weight,
                            "gender": element.player.gender,
                            "birthDate": moment(element.player.dob).format('YYYY-MM-DD HH:MM'),
                            "birthPlace": element.player.birth_place,
                            "description": "role "+element.player.role+ " "+ element.player.batting_style+" " + element.player.bowling_style+ " " + element.player.education,
                            "image": "https://planetcricket.com/public/images/logo1280x720.png"
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": persons
            }
        },

        metaInfo() {

            if (!this.team)
                return

            let title = `${Components['TeamDetails'].team.name}   Players` + " - PlanetCricket.com";
            let description = `Get the latest ${Components['TeamDetails'].team.name} Players ` + " - PlanetCricket.com";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        computed: {
            filteredPlayers() {
                var players = this.category != 'all' ? this.players.currentPlayers.filter((obj) => obj.type === this.category) : this.players.currentPlayers;
                var ids = players.map(o => o.player_id);
                players = players.filter(({player_id}, index) => !ids.includes(player_id, index + 1));
                return players;

            },

        },
        methods: {
            main() {
                return this.$axios.get(this.$TEAM_PLAYERS_DETAIL_API.replace(':team', this.$route.params.team))
                        .then(response => {
                            this.is_data_ready = true
                            this.players = response.data.result || [];

                            /* for (let i = 0; i < this.players.currentPlayers.length; i++) {
                                this.players.currentPlayers[i].player.dob = moment(String(this.players.currentPlayers[i].player.dob)).format('YYYY-MM-DD');
                                this.players.currentPlayers[i].player.age = this.ageCalculate(this.players.currentPlayers[i].player.dob);
                            } */
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            /*ageCalculate(DOB) {
                var date = new Date().toISOString().slice(0, 10);
                var datee = moment(date).format('YYYY-MM-DD');
                if (DOB < datee)
                {
                    console.log(this.age = Vue.filter('age')(DOB));
                    return this.age;
                } else
                {
                    return this.age = '';
                }
            } */
        }
    }
</script>

